export default __webpack_public_path__ + "static/media/linkedin.bdd46eac.svg";